import request from '@/utils/requestA'

//  报告详情-编辑使用
export function reportDetail(data) {
    return request({
        url: `/survey-data/report/reportDetail`,
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/brandInquiryA.js